import { MODELS } from "../lib/models";
import { KidFriendlyBadge } from "./KidFriendlyBadge";
import { AboutWhat } from "./AboutWhat";
import { SurpriseButton } from "./DebateExtras";

const EXAMPLES = [
  "Why do cats purr?",
  "How do black holes form?",
  "What's the strangest animal on Earth?",
];
const KID_EXAMPLES = ["Why is the sky blue?", "How do bees make honey?", "What did dinosaurs eat?"];

export const EmptyState = ({ onPick, isPro, kids, onKids, onSurprise }) => (
  <div data-testid="empty-state" className="what-rise pt-[6vh]">
    <p className="font-mono text-xs uppercase tracking-[0.2em] text-slate-500 mb-6">
      {kids ? "Kids Mode · safe answers for curious minds" : isPro ? "Three minds. One answer." : "Free plan · pick any one AI"}
    </p>
    <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight text-white leading-[1.05]">
      Ask <span className={kids ? "text-[#38BDF8]" : "text-[#D4FF3A]"}>WHAT?</span><br />
      <span data-testid="empty-state-subtitle" className="text-slate-500">
        {kids ? "What do you want to know today?" : isPro ? "Hear from every AI at once." : "Upgrade to hear from all three."}
      </span>
    </h1>
    {!kids && <div className="mt-6"><KidFriendlyBadge onClick={onKids} /></div>}
    <div className="mt-6">
      <SurpriseButton big onClick={onSurprise} />
      <span className="ml-3 text-xs text-slate-500">Start a fun debate on a random amazing topic</span>
    </div>
    <div className="mt-8 grid gap-2 max-w-xl">
      {(kids ? KID_EXAMPLES : EXAMPLES).map((e, i) => (
        <button key={e} data-testid={`example-question-${i}`} onClick={() => onPick(e)} className="what-example">
          {e}
        </button>
      ))}
    </div>
    <div className="mt-8 max-w-xl"><AboutWhat compact /></div>
    <div className="flex flex-wrap gap-2 mt-8">
      {MODELS.map((m) => (
        <span key={m.key} className="what-chip" style={{ "--c": m.color }}>
          <span className="w-1.5 h-1.5 rounded-full" style={{ background: m.color }} />
          {m.name} <span className="opacity-60">{m.version}</span>
        </span>
      ))}
    </div>
  </div>
);
